const VERIFY_REQUEST_DELAYS_MS = [50, 500, 5_000, 50_000];

async function sendVerifyRequest(touchpoint: string, hasCustomerId: string, delayMs: number, verifyId: string): Promise<void> {
	try {
		/*                                                */
		await fetch(`/benefit-cinema/verify?touchpoint=${encodeURIComponent(touchpoint)}&hasCustomerId=${encodeURIComponent(hasCustomerId)}&delayMs=${delayMs}&verifyId=${encodeURIComponent(verifyId)}`, { keepalive: true });
	} catch {
		/*                    */
	}
}

/**
 *
 *
 *
 */
export function scheduleCustomerIdVerification(touchpoint: string, root: HTMLElement | null): void {
	const userLoggedIn = root?.dataset.userLoggedIn;
	if (!userLoggedIn) {
		return;
	}

	const verifyId = crypto.randomUUID();

	for (const delayMs of VERIFY_REQUEST_DELAYS_MS) {
		window.setTimeout((): void => {
			void sendVerifyRequest(touchpoint, userLoggedIn, delayMs, verifyId);
		}, delayMs);
	}
}
